// src/UserContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

const UserContext = createContext(null);

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // 👈 control de carga
/*
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser); // Usuario sigue logueado tras refresh
      } else {
        setUser(null); // No hay usuario logueado
      }
    });
*/
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser || null);
      setLoading(false); // 👈 ya sabemos si hay usuario o no
    });
    return () => unsubscribe(); // Limpia el listener al desmontar
  }, []);

return (
    <UserContext.Provider value={{ user, setUser, loading }}>
      {!loading && children} {/* 👈 solo renderiza si terminó de cargar */}
    </UserContext.Provider>
  );
};